
<template>
    <img v-lazy="url" src="url"/>
</template>

<script>

export default {
  props:['content'],
  data(){
    return{
      url:require("../../assets/images/m_global_article_default@3x.png"),
    }
  },
  methods:{
    handleImg(){
      let content = this.content;
      var imgarr = content.match(/<img.+?>/ig);
      if(imgarr){
          var re2 = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
          this.url = imgarr[0].match(re2)[1];
            //结果
      }
    }
  },
  created(){
    this.handleImg()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modules/ArticleThumbnail.vue